import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "@flat-ui";
import { useDynamicHeight } from "@hooks/use-dynamic-height";
import { Box, Stack } from "@mui-wrapper";
import { ProjectMarkupsBoardColumns } from "@pages/project-details/project-markups/board/project-markups-board-columns";

/** Shortest the board gets on small windows, where the page scrolls to it instead */
const MIN_BOARD_HEIGHT = "20rem";
/** Shows the markups in a column per status, where they can be dragged to change their status */
export function ProjectMarkupsBoard(t0) {
  const $ = _c(12);
  const {
    markups,
    isLoading,
    onMarkupClick
  } = t0;
  let t1;
  if ($[0] !== isLoading) {
    t1 = {
      deps: [isLoading]
    };
    $[0] = isLoading;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    ref,
    height
  } = useDynamicHeight(t1);
  let t2;
  if ($[2] !== height) {
    t2 = {
      height,
      minHeight: MIN_BOARD_HEIGHT,
      display: "flex"
    };
    $[2] = height;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== isLoading || $[5] !== markups || $[6] !== onMarkupClick) {
    t3 = isLoading ? <Skeleton variant="rectangular" sx={{
      width: "100%",
      height: "100%",
      borderRadius: 1
    }} /> : <ProjectMarkupsBoardColumns markups={markups} onMarkupClick={onMarkupClick} />;
    $[4] = isLoading;
    $[5] = markups;
    $[6] = onMarkupClick;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== ref || $[9] !== t2 || $[10] !== t3) {
    t4 = <Stack><Box ref={ref} sx={t2}>{t3}</Box></Stack>;
    $[8] = ref;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}